import { cn } from '@/utils/cn';
import { Icon } from '@/components/Icons';

interface SpinnerProps {
  className?: string;
  size?: number;
}

/**
 * Spinner component for displaying a loading indicator.
 */
export const Spinner: React.FC<SpinnerProps> = ({ size = 24, className }) => {
  /**
   * Class names for the spinner element, including animation and
   * any additional classes passed via props.
   */
  const spinnerClassNames = cn(
    'animate-spin-clockwise',
    'animate-duration-1000',
    'animate-iteration-count-infinite',
    'text-brand-primary',
    className,
  );

  return <Icon name="CircleNotch" className={spinnerClassNames} size={size} />;
};

Spinner.displayName = 'Spinner';

export default Spinner;
